/* Global, site-wide behaviors: header scroll state, mobile nav, search
   toggle, generic accordions/tabs, collection filters panel + quick chips,
   and the "ver más" Ajax pagination for collection grids. Vanilla JS. */
(function () {
  var SCROLL_THRESHOLD = 120;

  /* ---------- Header scroll compact class ---------- */
  function initHeaderScroll() {
    var ticking = false;
    function update() {
      document.body.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* ---------- Mobile nav + search toggle ---------- */
  function initHeaderToggles() {
    var menuBtn = document.querySelector('[data-mobile-menu-toggle]');
    var menuPanel = document.getElementById('mobile-nav-panel');
    if (menuBtn && menuPanel) {
      menuBtn.addEventListener('click', function () {
        var open = menuBtn.getAttribute('aria-expanded') === 'true';
        menuBtn.setAttribute('aria-expanded', String(!open));
        menuPanel.hidden = open;
        menuBtn.textContent = open ? menuBtn.dataset.labelOpen || 'Menú' : 'Cerrar';
      });
    }

    var searchBtn = document.querySelector('.header-search-toggle');
    var searchPanel = document.getElementById('header-search-panel');
    if (searchBtn && searchPanel) {
      searchBtn.addEventListener('click', function () {
        var open = searchBtn.getAttribute('aria-expanded') === 'true';
        searchBtn.setAttribute('aria-expanded', String(!open));
        searchPanel.hidden = open;
        if (!open) searchPanel.querySelector('input[type="search"]').focus();
      });
    }
  }

  /* ---------- Generic accordion (main-product, features, promo box) ---------- */
  function toggleAccordion(item, trigger) {
    var isOpen = item.dataset.open === 'true';
    item.dataset.open = String(!isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      if (trigger.dataset.bound) return;
      trigger.dataset.bound = 'true';
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        if (item) { toggleAccordion(item, trigger); return; }

        /* promo box: trigger toggles a sibling panel by aria-controls */
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (panel) {
          var open = panel.dataset.open === 'true';
          panel.dataset.open = String(!open);
          trigger.setAttribute('aria-expanded', String(!open));
          trigger.textContent = open ? (trigger.dataset.labelClosed || 'Detalles') : (trigger.dataset.labelOpen || 'Ocultar');
        }
      });
    });
  }

  /* ---------- Tabs (product-reviews) ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-tab-trigger]').forEach(function (trigger) {
      if (trigger.dataset.bound) return;
      trigger.dataset.bound = 'true';
      trigger.addEventListener('click', function () {
        var group = trigger.closest('.tabs');
        var section = trigger.closest('section');
        group.querySelectorAll('[data-tab-trigger]').forEach(function (btn) {
          btn.setAttribute('aria-selected', 'false');
          btn.tabIndex = -1;
        });
        trigger.setAttribute('aria-selected', 'true');
        trigger.tabIndex = 0;
        section.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.tabPanel !== trigger.dataset.tab;
        });
      });
    });
  }

  /* ---------- Collection filters panel (mobile) ---------- */
  function initFiltersPanel() {
    var panel = document.getElementById('CollectionFiltersPanel');
    var openBtn = document.querySelector('[data-filters-open]');
    if (!panel) return;

    function setOpen(open) {
      panel.dataset.open = String(open);
      if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    }
    if (openBtn) openBtn.addEventListener('click', function () { setOpen(true); });
    panel.querySelectorAll('[data-filters-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.dataset.open === 'true') setOpen(false);
    });
  }

  /* ---------- Quick-filter chips (collection-filters.liquid) auto-submit ---------- */
  function initQuickFilters() {
    document.querySelectorAll('[data-quick-filter]').forEach(function (input) {
      input.addEventListener('change', function () {
        input.closest('form').submit();
      });
    });
  }

  /* ---------- Collection "ver más" Ajax pagination via Section Rendering API ---------- */
  function initLoadMore(root) {
    root.querySelectorAll('[data-load-more]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function () {
        var url = btn.dataset.nextUrl;
        if (!url) return;
        btn.disabled = true;
        var sep = url.indexOf('?') > -1 ? '&' : '?';
        fetch(url + sep + 'section_id=' + btn.dataset.sectionId)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-product-grid]');
            var currentGrid = document.querySelector('[data-product-grid]');
            if (newGrid && currentGrid) {
              Array.prototype.forEach.call(newGrid.children, function (card) {
                currentGrid.appendChild(card);
              });
              document.dispatchEvent(new CustomEvent('mesamayor:content-updated', { detail: { root: currentGrid } }));
            }
            var newLoadMoreWrap = doc.querySelector('[data-load-more-wrap]');
            var currentLoadMoreWrap = document.querySelector('[data-load-more-wrap]');
            if (newLoadMoreWrap && currentLoadMoreWrap) {
              currentLoadMoreWrap.outerHTML = newLoadMoreWrap.outerHTML;
              initLoadMore(document);
            }
            var newCount = doc.querySelector('[data-collection-count]');
            var currentCount = document.querySelector('[data-collection-count]');
            if (newCount && currentCount) currentCount.textContent = newCount.textContent;
          })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderScroll();
    initHeaderToggles();
    initAccordions(document);
    initTabs(document);
    initFiltersPanel();
    initQuickFilters();
    initLoadMore(document);
  });

  document.addEventListener('mesamayor:content-updated', function (e) {
    var root = (e.detail && e.detail.root) || document;
    initAccordions(root);
    initTabs(root);
  });
})();
